// extracted by mini-css-extract-plugin
export default {"tableRow":"TableRow_tableRow__8SNhU","tableRowActive":"TableRow_tableRowActive__VnViY"};